import WebpackerReact from 'webpacker-react'
import SearchFiltersNav from "../react/SearchFiltersNav"

export default class Searches {
  constructor(params) {
    WebpackerReact.setup({SearchFiltersNav})
    this.params = params;
  }

  show() {}
}
